import {
  SUGGESTIONS_FETCH_REQUEST,
  SUGGESTIONS_FETCH_SUCCESS,
  SUGGESTIONS_FETCH_FAIL,
  SUGGESTIONS_DISMISS,
} from '../actions/suggestions'
import { 
  SUGGESTION_TYPE_VERIFIED,
  SUGGESTION_TYPE_RELATED,
  SUGGESTION_TYPE_GROUPS,
  SUGGESTION_TYPE_FEEDS,
  SUGGESTION_TYPE_TAGS,
} from '../constants'
import {
  Map as ImmutableMap,
  List as ImmutableList,
  fromJS,
} from 'immutable'

const initialState = ImmutableMap({
  related: ImmutableMap({
    items: ImmutableList(),
    isLoading: false,
    isFetched: false,
  }),
  verified: ImmutableMap({
    items: ImmutableList(),
    isLoading: false,
    isFetched: false,
  }),
  groups: ImmutableMap({
    items: ImmutableList(),
    isLoading: false,
    isFetched: false,
  }),
  feeds: ImmutableMap({
    items: ImmutableList(),
    isLoading: false,
    isFetched: false,
  }),
  tags: ImmutableMap({
    items: ImmutableList(),
    isLoading: false,
    isFetched: false,
  }),
})

export default function suggestionsReducer(state = initialState, action) {
  switch(action.type) {
  case SUGGESTIONS_FETCH_REQUEST:
    return state.setIn([action.suggestionType, 'isLoading'], true)
  case SUGGESTIONS_FETCH_SUCCESS:
    const { suggestionType } = action
    return state.withMutations((map) => {
      const items = suggestionType === SUGGESTION_TYPE_TAGS ?
        fromJS(action.items)
        : fromJS(action.items.map(x => x.id))
      map.setIn([suggestionType, 'items'], items)
      map.setIn([suggestionType, 'isLoading'], false)
      map.setIn([suggestionType, 'isFetched'], true)
    })
  case SUGGESTIONS_FETCH_FAIL:
    return state.withMutations((map) => {
      map.setIn([suggestionType, 'isLoading'], false)
      map.setIn([suggestionType, 'isFetched'], true)
    })
  case SUGGESTIONS_DISMISS:
    return state.updateIn([action.suggestionType, 'items'], list => list.filterNot(id => id === action.id))
  default:
    return state
  }
}
